import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import CustomDataGrid from "components/tables/CustomDataGrid";
import { columns } from "pages/billingInvocies/helper";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import PaymentDialog from "./paymentDialog";
import { getPatientBillDocument } from "store/actions";
import { useDispatch, useSelector } from "react-redux";

const BillingInvoiceDetail = ({
  detailsOpen,
  setDetailsOpen,
  invoiceDetail,
  loadingDetails,
  porcessBill,
}) => {
  const [paymentOpen, setPaymentOpen] = useState(false);
  const dispatch = useDispatch();
  const practice_id = useSelector(
    (state) => state.auth.authData?.selected_practice
  );

  const handlePaymentSubmit = (paymentData) => {
    porcessBill(paymentData.action, paymentData);
    setPaymentOpen(false);
  };

  const fetchBillDocument = async (bill_id) => {
    const payload = {
      practice_id: practice_id.toString(),
      bill_id: bill_id.toString(),
    };
    dispatch(getPatientBillDocument(payload));
  };

  return (
    <Dialog
      maxWidth={false}
      open={detailsOpen}
      onClose={() => setDetailsOpen(false)}
      sx={{ width: "100vw", height: "80vh" }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
      >
        <Typography variant="h6">Invoice Details</Typography>
        <IconButton onClick={() => setDetailsOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box display="flex" gap={2} p={2} borderTop="1px solid #ddd">
        <Button onClick={() => porcessBill("void")} variant="outlined">
          Void
        </Button>
        <Button onClick={() => porcessBill("write_off")} variant="outlined">
          Write-Off
        </Button>
        <Button onClick={() => setPaymentOpen(true)} variant="outlined">
          Bill Payment
        </Button>
      </Box>
      <Box px={2}>
        <CustomDataGrid
          rows={invoiceDetail}
          columns={columns({ fetchBillDocument })}
          getRowId={(row) => row.bill_id}
          loading={loadingDetails}
        />
      </Box>
      <PaymentDialog
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        billedAmount={invoiceDetail?.[0]?.billed_amount}
        onSubmit={handlePaymentSubmit}
      />
    </Dialog>
  );
};

export default BillingInvoiceDetail;
